import { pickCss } from '@/shared/lib/css-utils';
import css from './day-category-warning.module.scss';

const styles = {
  root: pickCss(css, css.root),
  bar: pickCss(css, css.bar),
  body: pickCss(css, css.body),
  title: pickCss(css, css.title),
  desc: pickCss(css, css.desc),
  adjust: pickCss(css, css.adjust),
};

type DayCategoryWarningProps = {
  title: string;
  description: string;
  /** Opens recommendation tuning or another fix action. */
  onAdjust?: () => void;
  adjustLabel?: string;
};

/**
 * DayCategoryWarning — pen component `w8htb`. The inline amber callout shown
 * inside a day-category panel when the active category has a fit issue.
 * "Adjust" can open global recommendation tuning or re-suggest.
 */
export const DayCategoryWarning = ({
  title,
  description,
  onAdjust,
  adjustLabel = 'Adjust',
}: DayCategoryWarningProps) => (
  <div className={styles.root()} role="status">
    <span aria-hidden="true" className={styles.bar()} />
    <div className={styles.body()}>
      <span className={styles.title()}>{title}</span>
      <span className={styles.desc()}>{description}</span>
    </div>
    {onAdjust && (
      <button className={styles.adjust()} onClick={onAdjust} type="button">
        {adjustLabel}
      </button>
    )}
  </div>
);
